import { IRootState } from "../reducers/root";

export function selectEndpoint(state: IRootState): string {
    return state.config.config.endpoint;
}
